import ExtraInfoForm from "./extra-info-form";
import AssigneeInfoForm from "./assignee-info-form";
import AssigneeInfoSummary from "./assignee-info-summary";
import ExtraInfoSummary from "./extra-info-summary";

const AssignServiceOrderFormSteps = [
  {
    name: 'Assignee Info',
    description: "Information about the field agent.",
    accessor: "assigneeInfo",
    FormComponent: AssigneeInfoForm,
    SummaryComponent: AssigneeInfoSummary,
  },
  {
    name: 'Extra Info',
    description: 'Extra information about the service order .',
    accessor: "extraInfo",
    FormComponent: ExtraInfoForm,
    SummaryComponent: ExtraInfoSummary,
  },
]

export default AssignServiceOrderFormSteps;
